import { filter, mergeMap, of, timer } from 'rxjs'
import { catchError, retryWhen, switchMap } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import type { Epic } from '../../../index.js'
import { Actions } from '../../../Slice/index.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { withBlockingRequest } from '../../Application/withBlockingRequest.js'
import { startDownload } from '../../../../Util/startDownload.js'

const POLL_DELAY_MS = 3000 // Wait 3 seconds before retrying if 202 is returned

export const GetFastqEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.getFastqRequest.match),
    mergeMap((action) =>
      withBlockingRequest(
        OrderRepository.downloadFastq(action.payload.orderId).pipe(
          switchMap((response) => {
            const statusCode = response.status

            if (statusCode === 202) {
              // Request is still processing, retry after a delay
              return timer(POLL_DELAY_MS).pipe(mergeMap(() => of(action)))
            }

            if (statusCode === 200) {
              // Backend returned a redirect with S3 URL, trigger the download
              const s3DownloadUrl = response.data.link
              startDownload(s3DownloadUrl)
              return of(order.getFastqRequestSuccess({ orderId: action.payload.orderId, link: s3DownloadUrl }))
            }

            return of(order.getFastqRequestFailure({ error: new Error(`Unexpected response status: ${statusCode}`) }))
          }),
          retryWhen(serverIsNotAvailable()), // Retry on temporary server unavailability
          catchError((error) =>
            authenticationExpiredOr({
              error,
              failedRequest: action.type,
              failureAction: of(order.getFastqRequestFailure({ error: error }))
            })
          ),
          catchError((err) => of(order.getFastqRequestFailure({ error: err })))
        ),
        'Generating fastq bundle...',
        'This operation may take a moment, please wait...'
      )
    )
  )
